import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import * as React from 'react';
import { ScoreIcon } from 'fable/ScoreIcon';
import styles from './index.module.scss';
export const RatingPreview = ({ ratingStyle, question, className, }) => {
    const ratingScores = [1, 2, 3, 4, 5];
    return (_jsxs("div", Object.assign({ className: cn(styles.root, className) }, { children: [_jsx("div", Object.assign({ className: styles.question, dir: "auto" }, { children: question })), _jsx("div", Object.assign({ className: styles.ratingScale }, { children: _jsx("div", Object.assign({ className: styles.ratingScaleWrapper }, { children: ratingScores.map((score) => (_jsx(ScoreIcon, { score: score, style: ratingStyle }, `${ratingStyle}-${score}`))) })) }))] })));
};
